import React from "react";
import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

const cn = (...inputs) => twMerge(clsx(inputs));

const BorderBottomCard = ({ children, className = "", ...rest }) => {
  return (
    <div
      className={cn(`border-b border-gray-200 dark:border-gray-800 p-2.5 ${className}`)}
      {...rest}
    >
      {children}
    </div>
  );
};

export default BorderBottomCard;
